import { render, staticRenderFns } from "./AcceptedTerms.vue?vue&type=template&id=8dd23e4c&scoped=true&"
import script from "./AcceptedTerms.vue?vue&type=script&lang=ts&"
export * from "./AcceptedTerms.vue?vue&type=script&lang=ts&"
import style0 from "./AcceptedTerms.vue?vue&type=style&index=0&id=8dd23e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd23e4c",
  null
  
)

export default component.exports